

/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */



 $(function ($) {
    $('.slick').slick({
        prevArrow: '<button class="slick-prev slick-arrow  slide-arrow prev-arrow"><svg version="1.0" xmlns="http://www.w3.org/2000/svg" width="114.000000pt" height="90.000000pt" viewBox="0 0 114.000000 90.000000" preserveAspectRatio="xMidYMid meet"> <g transform="translate(0.000000,90.000000) scale(0.100000,-0.100000)" fill="#000000" stroke="none"> <path d="M435 860 c-11 -4 -109 -98 -217 -207 -180 -181 -198 -202 -198 -233 0 -32 17 -52 192 -227 l193 -193 57 0 c61 0 76 14 62 56 -4 10 -70 83 -148 162 l-141 142 453 0 452 0 0 60 0 60 -452 0 -453 0 142 143 c157 157 170 181 129 221 -26 27 -38 30 -71 16z"/> </g></svg></button>',
        nextArrow: '<button class="slick-next slick-arrow  slide-arrow next-arrow"><svg version="1.0" xmlns="http://www.w3.org/2000/svg" width="118.000000pt" height="90.000000pt" viewBox="0 0 118.000000 90.000000" preserveAspectRatio="xMidYMid meet"> <g transform="translate(0.000000,90.000000) scale(0.100000,-0.100000)" fill="#000000" stroke="none"> <path d="M695 845 c-43 -42 -29 -64 128 -222 l142 -143 -483 0 -482 0 0 -60 0 -60 482 0 483 0 -142 -142 c-77 -79 -144 -152 -147 -164 -13 -42 2 -54 63 -54 l57 0 192 193 c175 176 192 196 192 228 0 31 -17 51 -202 236 -127 126 -213 204 -230 208 -21 5 -33 1 -53 -20z"/></g></svg></button>',
        responsive: [
            {
              breakpoint: 1024,
              settings: {
                slidesToShow: 2,
                slidesToScroll: 2,
                infinite: true,
                dots: true,
                loop:true
              }
            },
            {
              breakpoint: 600,
              settings: {
                slidesToShow: 2,
                slidesToScroll: 2
              }
            },
            {
              breakpoint: 480,
              settings: {
                slidesToShow: 1,
                slidesToScroll: 1
              }
            }
            // You can unslick at a given breakpoint now by adding:
            // settings: "unslick"
            // instead of a settings object
          ]
    });

    
 
});

$(window).on("load", function () {
  var urlHash = window.location.href.split("#")[1];
  if (urlHash &&  $('#' + urlHash).length )
        $('html,body').animate({
            scrollTop: $('#' + urlHash).offset().top - 100
        }, 1000);
});


$(document).on('click', ".Linklist__Item a.Link,.Text--subdued", function() {
  $('html').removeClass('no-scroll');
  $('.PageOverlay').removeClass('is-visible');
  $('.SidebarMenu').attr("aria-hidden","true");
  $(".SidebarMenu").removeAttr("tabindex");
  // e.preventDefault();
 console.log('topScroll');
   var target = $(this).attr('href').split('#')[1];
   $('html, body').animate({
     scrollTop: ($('#' + target).offset().top - 100)
   }, 2000);
 });
 $(document).on('click','[data-action="open-drawer"]', function(){
    $('html').addClass('no-scroll');
    $('.PageOverlay').addClass('is-visible');
    $('.SidebarMenu').attr("aria-hidden","false");
    $(".SidebarMenu").attr("tabindex", "-1");  
 })

 $(window).scroll(function() {    
  var scroll = $(window).scrollTop();

  if (scroll >= 400) {
      $(".ButtonGroup__Mobile").addClass("ButtonGroup__Fixed");
  } else {
      $(".ButtonGroup__Mobile").removeClass("ButtonGroup__Fixed");
  }
});

$(document).on('click', ".toggle_prp_box", function() {
//$(".toggle_prp_box").click(function(){
  
  $(this).next(".prp_details").slideToggle();
})
$(function() {
  
    $('.ProductItem__Wrapper').matchHeight({
      byRow: true,
      property: 'min-height',
      //target: null,
      //remove: false
    });    
 

});


// // handle links with @href started with '#' only
// $(document).on('click', '.Link--secondary', function(e) {
//   setTimeout(function(){
//     var urlHash = window.location.href.split("#")[1];
//     if (urlHash &&  $('#' + urlHash).length )
//         $('html,body').animate({
//             scrollTop: $('#' + urlHash).offset().top - 100
//   }, 1000);
//   }, 500 )
  
// });
